import { useCallback } from 'react';
import { StyledAutoFlowGrid } from '~/app/pages/components/styled-auto-flow-grid';
import { gridAreas } from './config';
import { AutoFlowGridProps } from './types';

export const AutoFlowGrid = ({ direction, sources }: AutoFlowGridProps) => {
	const renderSources = useCallback(() => {
		return sources.filter(Boolean).map((imageSource, index) => {
			return (
				<img
					key={imageSource}
					src={imageSource}
					alt=""
					style={{
						gridArea: gridAreas[direction].itemAreas[index],
						aspectRatio: gridAreas[direction].aspectRatios[index],
					}}
				/>
			);
		});
	}, [JSON.stringify(sources)]);

	return <StyledAutoFlowGrid $direction={direction}>{renderSources()}</StyledAutoFlowGrid>;
};
